import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FooterWrapper, {
  MenuWrapper,
  CopyrightArea,
  SecondaryFooter,
  Text
} from './Footer.style';

const Footer = ({ logo, menu, bgSrc, copyright, className, path,admin }) => {
  return (
    <>
      <FooterWrapper id="footer" className={className} bg-img={bgSrc}>
        {logo && logo}
        {menu && <MenuWrapper>{menu}</MenuWrapper>}
        {copyright && <CopyrightArea>{copyright}</CopyrightArea>}
        {/* {admin && <Text>
          <Link to={""}>Administration hôtel</Link>
          </Text>} */}

      </FooterWrapper>
      {!!path && <SecondaryFooter />}
    </>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.element,
  menu: PropTypes.element,
  bgSrc: PropTypes.string,
  copyright: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default Footer;
